<!-- login popup submit start -->

<div class="login-content" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div *ngIf="type == 1" class="modal-content">
      <div class="modal-header p-0">
        <div class="modal-logo"><a href="#"><img src="assets/images/bg-logo.svg" alt="logo"></a></div>
        <h5 class="modal-title" id="loginmodal">Login or Signup</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeButtonClick()">
          <img src="assets/images/cancel-icon.svg" alt="icon" />
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="login-detail">
          <form [formGroup]="signInFormgroup">
            <div class="enter-phone-number">Enter your phone number to verify yourself</div>
            <div class="input-box-detail">
              <div class="code-input"><input type="text" disabled value="+91"></div>
              <div class="number-input">
                <input type="tel" maxlength="10" minlength="10" class="" id="phone_number"
                  formControlName="phone_number" placeholder="Mobile Number.."
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');" (keyup.enter)="getOtp()"/>
                <div *ngIf="phonef['phone_number'].touched && phonef['phone_number'].invalid"
                  class="alert alert-danger alert-text">
                  <div *ngIf="phonef['phone_number'].errors && phonef['phone_number'].errors['required']">Mobile Number
                    is
                    required.</div>
                  <div *ngIf="phonef['phone_number'].hasError('pattern')">
                    Mobile Number is invalid.
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer p-0">
        <button type="button" data-bs-dismiss="modal" class="btn btn-secondary submit-c-black"
          (click)="getOtp()" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"><i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> Submit</button>
      </div>
    </div>
    <div *ngIf="type == 2" class="modal-content">
      <div class="modal-header p-0">
        <div class="modal-logo"><a><img src="assets/images/bg-logo.svg" alt="logo"></a></div>
        <h5 class="modal-title" id="signup-modal">Signup</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeButtonClick()">
          <img src="assets/images/cancel-icon.svg" alt="icon" />
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="login-detail">
          <form [formGroup]="addUserFormgroup">
            <div class="enter-phone-number">Create your Account</div>
            <div class="signup-field">
              <input type="text" id="firstName" formControlName="first_name" placeholder="First name">
              <input type="text" id="lastName" formControlName="last_name" placeholder="Last name">
              <input type="email" id="email" formControlName="email" placeholder="Email Id">
              <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger alert-text">
                <div *ngIf="f['email'].hasError('pattern')">
                  Email is invalid.
                </div>
              </div>

              <!-- new gender login popup new design  -->
              
              <div class="d-lg-block">
                <div class="p-relative" (click)="genderDropdown()">
                    <div class="gender-menu">
                        <div class="gender-detail">
                          {{selectedGender == 2 ? 'Female' : selectedGender == 1 ? 'Male' : selectedGender == 0 ? 'Other' : 'Select Gender'}}
                        </div>
                    </div>
                    <div class="gender-select-new">
                        <ul>
                          <li [ngClass]="selectedGender == 2 ? 'active' : ''" (click)="selectGender(2)">Female</li>
                          <li [ngClass]="selectedGender == 1 ? 'active' : ''" (click)="selectGender(1)">Male</li>
                          <li [ngClass]="selectedGender == 0 ? 'active' : ''" (click)="selectGender(0)">Other</li>
                        </ul>
                    </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer mt-2 p-0">
        <button type="button" class="btn btn-secondary submit-c-black" [disabled]="addUserFormgroup.invalid"
          (click)="addUser()" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"><i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> Submit</button>
      </div>
    </div>
    <div *ngIf="type == 3" class="modal-content">
      <div class="modal-header p-0">
        <div class="modal-logo"><a href="#"><img src="assets/images/bg-logo.svg" alt="logo"></a></div>
        <h5 class="modal-title" id="loginmodal">Login or Signup</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeButtonClick()">
          <img src="assets/images/cancel-icon.svg" alt="icon" />
        </button>
      </div>
      <div class="modal-body p-0 spinner-modal" [ngClass]="{'no-pointer-events': isLoading && resendLoader, '': !isLoading || !resendLoader}">
        <i *ngIf="isLoading && resendLoader" class="fa me-1" [ngClass]="{'fa-spin fa-spinner new-spinner': isLoading && resendLoader, '': !isLoading || !resendLoader}"></i>
        <div class="login-detail">
          <form [formGroup]="verifyOtpFormgroup">
            <div class="enter-phone-number">Enter your phone number to verify yourself</div>
            <div class="signup-field">
              <input type="tel" maxlength="4" minlength="4" id="otp" formControlName="otp" placeholder="Enter OTP"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');" (keyup.enter)="loginWithOTP()">
              <div *ngIf="otpf['otp'].touched && otpf['otp'].invalid" class="alert alert-danger alert-text">
                <div *ngIf="otpf['otp'].errors && otpf['otp'].errors['required']">OTP is
                  required.</div>
                <div *ngIf="otpf['otp'].hasError('pattern')">
                  OTP is invalid.
                </div>
              </div>
            </div>
            <div class="did-not-resend">Didn't receive OTP? <a (click)="getOtp()">Resend</a></div>
          </form>
        </div>
      </div>
      <div class="modal-footer mt-2 p-0">
        <button type="button" data-bs-dismiss="modal" class="btn btn-secondary submit-c-black" (click)="loginWithOTP()"
          [disabled]="verifyOtpFormgroup.invalid" [ngClass]="{'no-pointer-events': isLoading && !resendLoader, '': !isLoading}"><i *ngIf="isLoading && !resendLoader" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i>
          Verify Otp</button>
      </div>
    </div>
  </div>
</div>

<!-- login popup submit end -->

<!-- signup start -->

<div class="modal fade login-content" id="signup" tabindex="-1" aria-labelledby="signup-modal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header p-0">
        <div class="modal-logo"><a href="#"><img src="assets/images/bg-logo.svg" alt="logo"></a></div>
        <h5 class="modal-title" id="signup-modal">Signup</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <img src="assets/images/cancel-icon.svg" alt="icon" />
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="login-detail">
          <form [formGroup]="addUserFormgroup">
            <div class="enter-phone-number">Create your Account</div>
            <div class="signup-field">
              <input type="text" placeholder="First Name *" formControlName="first_name">
              <input type="text" placeholder="Last Name *" formControlName="last_name">
              <input type="text" placeholder="Email ID *" formControlName="email">
              <select formControlName="gender">
                <option value="">Gendar</option>
                <option value="1">Male</option>
                <option value="2">Female</option>
              </select>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer mt-2 p-0">
        <button type="button" data-bs-dismiss="modal" class="btn btn-secondary submit-c-black" data-bs-toggle="modal"
          data-bs-target="#otp-detail">Submit</button>
      </div>
    </div>
  </div>
</div>

<!-- signup end -->